import { sanitizeHtml } from '../core/sanitize';

export type CopyMethod = 'clipboard-rich' | 'clipboard-text' | 'fallback';

function legacyCopyHtml(html: string): boolean {
  const selection = window.getSelection();
  const range = document.createRange();
  const container = document.createElement('div');
  container.setAttribute('contenteditable', 'true');
  container.setAttribute('aria-hidden', 'true');
  container.style.position = 'fixed';
  container.style.left = '-9999px';
  container.innerHTML = sanitizeHtml(html, undefined, false);
  document.body.append(container);
  range.selectNodeContents(container);
  selection?.removeAllRanges();
  selection?.addRange(range);
  const copied = document.execCommand('copy');
  selection?.removeAllRanges();
  container.remove();
  return copied;
}

function legacyCopyText(text: string): boolean {
  const textarea = document.createElement('textarea');
  textarea.value = text;
  textarea.setAttribute('readonly', '');
  textarea.style.position = 'fixed';
  textarea.style.left = '-9999px';
  document.body.append(textarea);
  textarea.select();
  const copied = document.execCommand('copy');
  textarea.remove();
  return copied;
}

export async function copyFormatted(html: string, text: string): Promise<CopyMethod> {
  const safeHtml = sanitizeHtml(html, undefined, false);
  if (navigator.clipboard?.write && typeof window.ClipboardItem !== 'undefined') {
    try {
      const item = new window.ClipboardItem({
        'text/html': new Blob([safeHtml], { type: 'text/html' }),
        'text/plain': new Blob([text], { type: 'text/plain' }),
      });
      await navigator.clipboard.write([item]);
      return 'clipboard-rich';
    } catch {
      if (legacyCopyHtml(safeHtml)) return 'fallback';
    }
  }
  if (legacyCopyHtml(safeHtml)) return 'fallback';
  throw new Error('Der Browser hat den formatierten Kopiervorgang blockiert. Bitte markiere die Vorschau manuell.');
}

export async function copyPlain(text: string): Promise<CopyMethod> {
  if (navigator.clipboard?.writeText) {
    try {
      await navigator.clipboard.writeText(text);
      return 'clipboard-text';
    } catch {
      if (legacyCopyText(text)) return 'fallback';
    }
  }
  if (legacyCopyText(text)) return 'fallback';
  throw new Error('Der Browser hat den Kopiervorgang blockiert. Bitte markiere den Text manuell.');
}
